import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import { Icon } from 'core/components/Icon/Icon.style';
import * as mx from 'core/styles/mixins';

export const Tooltip = styled.button`
	${mx.buttonReset}
	${mx.square('30px')}
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer !important;

	${({ theme }) => css`
		${Icon} {
			color: ${theme.global.colors.secondary};
		}

		&:hover,
		&:focus {
			${Icon} {
				color: ${lighten(0.2, theme.global.colors.secondary.color)};
			}
		}

		&:active {
			${Icon} {
				color: ${lighten(0.1, theme.global.colors.secondary.color)};
			}
		}
	`}
`;

export const Content = styled.div`
	.tooltip-text {
		padding: 10px;

		${({ theme }) => css`
			background-color: ${theme.global.colors.secondary};

			&.place-top {
				&::after {
					border-top-color: ${theme.global.colors.secondary} !important;
				}
			}

			&.place-right {
				&::after {
					border-right-color: ${theme.global.colors.secondary} !important;
				}
			}

			&.place-bottom {
				&::after {
					border-bottom-color: ${theme.global.colors.secondary} !important;
				}
			}

			&.place-left {
				&::after {
					border-left-color: ${theme.global.colors.secondary} !important;
				}
			}
		`}
	}
`;

export const TooltipContent = styled.div`
	font-size: 14px;

	p {
		font-size: 14px;
		hyphens: auto;
	}

	p:first-of-type {
		margin-top: 0;
	}

	p:last-of-type {
		margin-bottom: 0;
	}
`;
